import { memo } from 'react';

/* SVG-иконка из строки прототипа — без обёртки, чтобы селекторы вида `.x > svg` работали как в прототипе */
const camel = (k: string) => (k === 'class' ? 'className' : k.replace(/-([a-z])/g, (_, c) => c.toUpperCase()));
const cache = new Map<string, { attrs: Record<string, string>; inner: string }>();

function parse(src: string) {
  let p = cache.get(src);
  if (p) return p;
  const m = src.match(/^<svg([^>]*)>([\s\S]*)<\/svg>$/);
  const attrs: Record<string, string> = {};
  if (m) for (const a of m[1].matchAll(/([\w:-]+)="([^"]*)"/g)) attrs[camel(a[1])] = a[2];
  p = { attrs, inner: m ? m[2] : '' };
  cache.set(src, p);
  return p;
}

export const Svg = memo(function Svg({ src }: { src: string }) {
  const { attrs, inner } = parse(src);
  return <svg {...attrs} dangerouslySetInnerHTML={{ __html: inner }} />;
});
